import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';
import { WindowLocationServiceInterface } from 'pf-frontend-common/src/service/window-location/service.interface';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { AgentSerpStore } from 'common/module/agent-serp/store';
import { DataStore } from 'common/module/data/store';
import { DataStoreEvent } from 'common/module/data/store.event';
import { PaginationComponentPropsInterface } from 'common/module/pagination/component-props.interface';

/**
 * @deprecated Duplication, please use the generic common/module/pagination/view-store instead
 */
export class AgentTabPaginationViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: PaginationComponentPropsInterface;

  /**
   * Constructor
   */
  constructor(
    eventEmitter: EventEmitterInterface,
    private windowLocationService: WindowLocationServiceInterface,
    private agentSerpStore: AgentSerpStore
  ) {
    super(eventEmitter);

    this.agentSerpStore.getEventEmitter().addListener(DataStoreEvent.updateState, this.onUpdateStateAgentSerpStore);
  }

  /**
   * @inheritDoc
   */
  public initialize(): void {
    this.state = {
      currentPage: 1,
      limit: 0,
      total: 0,
      pageCount: 0,
      href: '',
      nextLinkTitle: i18nTranslate('next'),
      prevLinkTitle: i18nTranslate('prev'),

      // TODO-FE[later]: get from global config for desktop
      amountOfPagesShown: 10,
      onClickPage: this.onClickPage,
    };

    this.refreshState();
  }

  /**
   * Refresh pagination state
   *
   * @deprecated Stinky "refresh state" keywords detected, most likely a logic somewhere else is wrong
   */
  private refreshState(): void {
    this.setState({
      ...this.state,
      currentPage: this.agentSerpStore.getState().params['page[number]'],
      limit: this.agentSerpStore.getState().params['page[limit]'],
      total: this.agentSerpStore.getState().results.count,
    });
  }

  /**
   * Click page in pagination
   */
  private onClickPage = (e: Event, page: number): void => {
    e.preventDefault();

    this.agentSerpStore.updateParams({
      ['page[number]']: page,
    });

    const queryData = {
      ...this.windowLocationService.getQueryData(),
      agents: {
        ...this.windowLocationService.getQueryData().agents,
        page,
      },
    };

    if (page === 1) {
      delete queryData.agents.page;
    }

    this.windowLocationService.replace(this.windowLocationService.getPathname(), {
      hash: this.windowLocationService.getHash(),
      queryData,
    });
  };

  /**
   * Agent serp store state updated
   */
  private onUpdateStateAgentSerpStore = (): void => {
    this.refreshState();
  };
}
